module.exports = __webpack_public_path__ + "static/media/testimonial-alexis-at.165940d0.webp";